"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnifiedProductVariant;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _image = require("@site/pattern-library-core/image");
var _productIcon = _interopRequireDefault(require("../../elements/other/product-list-page/product-icon"));
var _productTileActions = _interopRequireDefault(require("../../elements/other/product-list-page/product-tile-actions"));
var _tagItem = _interopRequireDefault(require("../../elements/other/product-list-page/filters/tag-item"));
/* VENDOR */

/* LOCAL */

const ProductTileContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ProductTileContainer",
  class: "pl-p1ob8md4",
  vars: {
    "p1ob8md4-6": [({
      renderAsHeroTile
    }) => renderAsHeroTile ? _patternLibraryUtils.density['8'] : _patternLibraryUtils.density['18']],
    "p1ob8md4-7": [({
      renderAsHeroTile
    }) => renderAsHeroTile ? '1 / 3' : 'auto']
  }
});
const SectionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SectionWrapper",
  class: "pl-s1sh440j"
});
const ProductIconContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ProductIconContainer",
  class: "pl-pfztrdo"
});
const Flag = /*#__PURE__*/(0, _react2.styled)(_tag.default)({
  name: "Flag",
  class: "pl-f8bq9vg"
});
const HeaderContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeaderContainer",
  class: "pl-h13d03q5"
});
const TagContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TagContainer",
  class: "pl-t18ap4zl"
});
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentContainer",
  class: "pl-cnz8ujy"
});
const Link = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Link",
  class: "pl-lhf4gni"
});
const FeaturedImage = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "FeaturedImage",
  class: "pl-fzbkwv0"
});

/**
 * Render the product tile, product variant.
 * @memberof module:ProductTile
 *
 * @param {object} props React props
 * @param {string} props._name Sitecore item name for tracking
 * @param {string} props.actionsLayout Tile actions section layout
 * @param {object} props.object Product description
 * @param {object} props.cta The CTA object
 * @param {object} props.content The content object
 * @param {object} props.featuredImage Hero tile image
 * @param {object} props.featuredCategory shared text object with category name
 * @param {string} props.id Id string
 * @param {bool} props.isFeaturedProductTile Hero tile flag
 * @param {object} props.priceLockup Price lockup object
 * @param {string} props.productIcon Primary product icon object
 * @param {string} props.productName Product name
 * @param {array} props.productTags Product tags
 * @param {string} props.saleFlagText Sale flag text
 * @param {array} props.secondaryProductIcons Secondary product icon objects
 * @param {string} props.textLink Linking text
 * @returns {React.ReactElement} Product tile, product variant
 * @public
 */
function UnifiedProductVariant({
  _name,
  actionsLayout,
  content,
  cta,
  renderAsHeroTile,
  featuredImagePortrait,
  featuredImageLandscape,
  planbox,
  modalRetryText,
  priceLockup,
  productIcons,
  productName,
  productTags,
  saleFlagText,
  linkText,
  linkHref,
  useIconPlus = false,
  gridIndex,
  ...rest
}) {
  const {
    Text: productDescription
  } = content;
  return /*#__PURE__*/_react.default.createElement(ProductTileContainer, (0, _extends2.default)({
    renderAsHeroTile: renderAsHeroTile
  }, rest), /*#__PURE__*/_react.default.createElement(SectionWrapper, null, /*#__PURE__*/_react.default.createElement(ProductIconContainer, null, productIcons?.map(({
    icon,
    ariaLabel
  }, i) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: i
  }, /*#__PURE__*/_react.default.createElement(_productIcon.default, {
    icon: icon,
    ariaLabel: ariaLabel
  }), useIconPlus && i === 0 && productIcons?.length > 1 && /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: "plus"
  })))), saleFlagText && /*#__PURE__*/_react.default.createElement(Flag, {
    "data-cy": "flag",
    text: saleFlagText,
    design: "warning"
  }), /*#__PURE__*/_react.default.createElement(HeaderContainer, {
    "data-cy": "header"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "heading",
    size: 0,
    text: productName,
    className: "gdSherpa",
    "data-cy": "paragraph"
  }), productTags && /*#__PURE__*/_react.default.createElement(TagContainer, null, productTags.slice(0, 3).map(({
    tagName: {
      Text: label
    }
  }, i) => label && /*#__PURE__*/_react.default.createElement(_tagItem.default, {
    variant: "tile",
    key: i,
    label: label
  })))), /*#__PURE__*/_react.default.createElement(ContentContainer, {
    "data-cy": "content"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    "data-cy": "tile-text"
  }, productDescription), /*#__PURE__*/_react.default.createElement(Link, (0, _extends2.default)({
    "data-cy": "tile-link",
    href: linkHref
  }, _patternLibraryUtils.tracking.create(`tile_link_${_name}`, true, false)), /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    size: -1
  }, linkText))), /*#__PURE__*/_react.default.createElement(_productTileActions.default, {
    actionsLayout: actionsLayout,
    cta: cta,
    priceLockup: priceLockup,
    planbox: planbox,
    modalRetryText: modalRetryText,
    gridIndex: gridIndex
  })), renderAsHeroTile && /*#__PURE__*/_react.default.createElement(FeaturedImage, {
    isPromo: false,
    imgLoading: "eager",
    portrait: featuredImagePortrait?.url,
    landscape: featuredImageLandscape?.url ?? featuredImagePortrait?.url
  }));
}
UnifiedProductVariant.propTypes = {
  _name: _propTypes.default.string.isRequired,
  actionsLayout: _propTypes.default.oneOf(['button', 'domain-search', 'price-lockup-and-button', 'planbox-modal']),
  content: _propTypes.default.object,
  cta: _propTypes.default.object,
  featuredImagePortrait: _propTypes.default.object,
  featuredImageLandscape: _propTypes.default.object,
  id: _propTypes.default.string,
  renderAsHeroTile: _propTypes.default.bool,
  planbox: _propTypes.default.object,
  modalRetryText: _propTypes.default.string,
  priceLockup: _propTypes.default.object,
  productIcons: _propTypes.default.arrayOf(_propTypes.default.shape(_productIcon.default.propTypes)),
  productName: _propTypes.default.string,
  productTags: _propTypes.default.arrayOf(_propTypes.default.shape(_tag.default.propTypes)),
  saleFlagText: _propTypes.default.string,
  linkText: _propTypes.default.string,
  linkHref: _propTypes.default.string,
  useIconPlus: _propTypes.default.bool,
  gridIndex: _propTypes.default.number
};